import { render, staticRenderFns } from "./CSupportBox.vue?vue&type=template&id=772ba93e&"
import script from "./CSupportBox.vue?vue&type=script&lang=js&"
export * from "./CSupportBox.vue?vue&type=script&lang=js&"
import style0 from "./CSupportBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports